import { render, staticRenderFns } from "./QuickInvoiceView.vue?vue&type=template&id=62c8587d"
import script from "./QuickInvoiceView.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports